import Vue from 'vue'
import Router from 'vue-router'
import answer from '@/view/answer/index.vue'
import index from '@/view/wel/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      redirect: to => ({
        path: '/index',
        query: to.query
      })
    },

    {
      path: '/answer',
      name: 'answer',
      component: answer
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '*',
      redirect: to => ({
        path: '/index',
        query: to.query
      })
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js